module.exports = __webpack_public_path__ + "img/4-3.04868b6b.svg";